import _extends from "@babel/runtime/helpers/extends";

/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../internal'; // eslint-disable-next-line react/display-name

var IconComponent = React.forwardRef(function (props, ref) {
  return React.createElement("svg", _extends({}, props, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), React.createElement("g", {
    id: "16x16/shower"
  }, React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.5C0 2.46243 2.46243 0 5.5 0C7.64412 0 9.50168 1.2269 10.4089 3.01695C12.9336 3.22714 14.9283 5.36641 14.9981 8H16V10H4V8H5.00189C5.05871 5.85738 6.38959 4.04195 8.24339 3.32634C7.60226 2.51826 6.61165 2 5.5 2C3.567 2 2 3.567 2 5.5V15H0V5.5ZM13 14C12.4477 14 12 13.5523 12 13C12 12 13 11 13 11C13 11 14 12 14 13C14 13.5523 13.5523 14 13 14ZM9 15C9 15.5523 9.44772 16 10 16C10.5523 16 11 15.5523 11 15C11 14 10 13 10 13C10 13 9 14 9 15ZM7 14C6.44771 14 6 13.5523 6 13C6 12 7 11 7 11C7 11 8 12 8 13C8 13.5523 7.55229 14 7 14Z",
    fill: "currentColor"
  })));
});
/**
 * Компоненты иконки <br />
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.<br />
 * Подключение иконки: `import { Shower16 } from '@cian/ui-kit/icons';`, <br />
 * где 16 - это размер иконки в пикселях.
 */

export var Shower16 = createIcon(IconComponent);